import { render, staticRenderFns } from "./SelecionarImovelDialog.vue?vue&type=template&id=4a83a28a&"
import script from "./SelecionarImovelDialog.vue?vue&type=script&lang=js&"
export * from "./SelecionarImovelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports